import "./index.scss";
import React, { useContext, useState } from "react";
import { AiOutlineClose, AiOutlineCheck } from "react-icons/ai";
import { Modal } from "src/component/Modal";
import { ScreenTitle, FlexRow, Button, TextInput, AppLabel } from "src/style";
import VisibilityContext from "src/provider/state-manager/visibilityProvider";
import ApiContext from "src/provider/API/call-service";

export const ResetPasswordModal = () => {
  const { visibility, setModal, notifier } = useContext(VisibilityContext);
  const {API} = useContext(ApiContext)

  const [data, setData] = useState({
    newPassword: "",
    confirmPassword: ""
  })

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const {value} = e.target;

    setData({
        ...data,
        [e.target.name] : value,
    })
  }

  const handleCancel = () => {
    setData({ newPassword: "", confirmPassword: "" });
    setModal({ key: "resetPassword", value: false });
  };

  const handleSubmit = async (e: React.SyntheticEvent) => {
    e.preventDefault();

    // check if password fields match
    if (data.newPassword !== data.confirmPassword) {
      notifier.show("Password fields don't match");

      return;
    }

    await API.resetPassword(data.newPassword);

    // perform some actions
    handleCancel();
}

return(
    <Modal
      isOnMenu
      className="view-result-modal"
      open={visibility.resetPassword}
      cancel={handleCancel}
    >
      <ScreenTitle color="#712126" textSize="2"  bottomMargin="4">
        Reset Password
      </ScreenTitle>

      {/* Reset password */}

      <form onSubmit={handleSubmit}>

        {/* New Paassword */}
          <AppLabel  
            textSize='1.2'
            fontWeight='600'
            color='#374957'
            >
              New password
            </AppLabel>

          <TextInput
            width="100%"
            borderColor="#8A8A8A"
            topPadding="1.2"
            leftPadding="2.5"
            rightPadding="2.5"
            bottomPadding="1.2"
            className="broadcast-mail-input"
          >
            <input
              required
              type="password"
              value={data.newPassword}
              onChange={handleChange}
              name="newPassword"
              placeholder="Enter New Password"
            />
          </TextInput>

        {/* Confirm New Password */}
        <div className="div">
        <AppLabel  
            textSize='1.2'
            fontWeight='600'
            color='#374957'
            >
              Confirm password
            </AppLabel>

          <TextInput
            width="100%"
            borderColor="#8A8A8A"
            topPadding="1.2"
            leftPadding="2.5"
            rightPadding="2.5"
            bottomPadding="1.2"
            className="broadcast-mail-input"
          >
            <input
              required
              type="password"
              value={data.confirmPassword}
              onChange={handleChange}
              name="confirmPassword"
              placeholder="Confirm password"
            />
          </TextInput>
          </div>

        <FlexRow isMaxWidth>
          <FlexRow
            topMargin="2"
            justifyContent="space-between"
            className="btn-container"
          >
            <Button
              hoverColor="#A77B37"
              onClick={handleCancel}
              className="view-result-btn cancel"
            >
              <AiOutlineClose size={17} />
              Cancel
            </Button>
            <Button
              type="submit"
              hoverBgColor="#fff"
              hoverColor="#A77B37"
              borderColor="#A77B37"
              className="view-result-btn confirm"
            >
              <AiOutlineCheck size={17} />
              Reset
            </Button>
          </FlexRow>
        </FlexRow>
      </form>
    </Modal>
)
}